import { Box, Button, IconButton, InputBase, Avatar as MuiAvatar } from "@mui/material";

import { styled } from "@mui/material/styles";

export const HeaderContainer = styled(Box)(({ theme }) => ({
  display: "grid",
  gridTemplateColumns: "1fr auto 1fr",
  alignItems: "center",
  height: "100px",
  width: "100%",
  borderBottom: `1px solid ${theme.colors.neutral.softGray}`,
  padding: theme.spacing(2),
  position: "relative",
  zIndex: theme.zIndex.drawer + 1,
  backgroundColor: "white",
}));

export const MenuButton = styled(IconButton)(({ theme }) => ({
  display: "flex",
  [theme.breakpoints.up("desktop")]: {
    display: "none",
  },
  color: theme.colors.neutral.black,
  alignItems: "center",
  justifyContent: "center",
}));

export const SearchButtonMobile = styled(IconButton)(() => ({
  padding: 0,
  display: "flex",
  marginRight: "12px",
}));

export const AvatarButtonDesktop = styled(Button)(({ theme }) => ({
  padding: 0,
  display: "flex",
  marginLeft: theme.spacing(5),
  "&:hover": {
    backgroundColor: "transparent",
  },
  buttonRadius: "50%",
  textDecoration: "none",
}));

export const Avatar = styled(MuiAvatar)(({ theme }) => ({
  width: "2.5rem",
  height: "2.5rem",
}));

export const SearchBar = styled(Box)(({ theme }) => ({
  position: "relative",
  backgroundColor: theme.colors.neutral.lightGray,
  borderRadius: "50px",
  marginLeft: 0,
  width: "35%",
  borderColor: "transparent",
  borderWidth: "1px",
  borderStyle: "solid",
  transition: "border-color 0.3s ease-in-out, width 0.3s ease-in-out",
  height: 44,
  display: "flex",
  alignItems: "center",

  "&:hover": {
    borderColor: theme.colors.primary.slalomBlue,
  },
  "&:focus-within": {
    width: "60%",
    borderColor: theme.colors.primary.slalomBlue,
  },
}));

export const SearchIconWrapper = styled("div")(({ theme }) => ({
  padding: theme.spacing(0, 2),
  height: "100%",
  position: "absolute",
  pointerEvents: "none",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
}));

export const ClearIconWrapper = styled("div")(({ theme }) => ({
  padding: theme.spacing(0, 2),
  height: "100%",
  position: "absolute",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  right: 0,
  top: 0,
  cursor: "pointer",
}));

export const AvatarButtonMobile = styled(IconButton)(({ theme }) => ({
  padding: 0,
  marginLeft: theme.spacing(5),
  display: "flex",
}));

export const LogoWrapper = styled(Box)(({ theme }) => ({
  position: "absolute",
  left: "50%",
  transform: "translateX(-50%)",
  display: "flex",
  alignItems: "center",
  gap: theme.spacing(2),
}));

export const LogoDivider = styled("img")(() => ({
  height: "32px",
  alignSelf: "center",
}));

export const SearchInput = styled(InputBase)(({ theme }) => ({
  width: "100%",
  "& .MuiInputBase-input": {
    fontSize: 14,
    lineHeight: "44px",
    height: 44,
    padding: theme.spacing(0, 3, 0, 0),
    paddingLeft: `calc(1em + ${theme.spacing(4)})`,
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
    color: theme.colors.neutral.black,
  },

  "& .MuiInputBase-input::placeholder, & input::placeholder": {
    fontSize: 14,
    color: theme.colors.neutral.darkGray,
    opacity: 1,
  },
}));

export const CircleIconButton = styled(IconButton)(({ theme }) => ({
  '&&': {
    width: 44,
    height: 44,
    borderRadius: '50%',
    backgroundColor: theme.colors.neutral.lightGray,
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    boxShadow: 'none',
    transition: 'none',
  },
  '&&:hover, &&:active, &&:focus': {
    backgroundColor: theme.colors.neutral.lightGray,
    boxShadow: 'none',
  },
  '& .MuiTouchRipple-root': { display: 'none' },
}));

export const SearchIconButton = styled(CircleIconButton)(({ theme }) => ({
  '&&': {
    marginTop: 2,
  },
  '& .MuiSvgIcon-root': {
    color: theme.colors.primary.slalomBlue,
    fontSize: 24,
  },
}));

export const CloseIconButton = styled(CircleIconButton)(({ theme }) => ({
  '&& .MuiSvgIcon-root': {
    color: theme.colors.neutral.darkGray,
    fontSize: 24,
  },
}));

export const RightIconWrapper = styled('div')(({ theme }) => ({
  marginRight: theme.spacing(2),
  display: 'inline-flex',
}));

export const RightSection = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'flex-end',
  gap: theme.spacing(2),
}));

export const FeedbackLink = styled('a')(({ theme }) => ({
  display: 'inline-flex',
  alignItems: 'center',
  fontFamily: 'Slalom Sans',
  fontSize: 14,
  fontWeight: 400,
  color: theme.colors.primary.slalomBlue ?? theme.colors.primary.slalomBlue,
  textDecoration: 'underline',
  lineHeight: '24px',
  cursor: 'pointer',
}));
